import { render, staticRenderFns } from "./su1Details.vue?vue&type=template&id=eefc3504&scoped=true"
import script from "./su1Details.vue?vue&type=script&lang=js"
export * from "./su1Details.vue?vue&type=script&lang=js"
import style0 from "./su1Details.vue?vue&type=style&index=0&id=eefc3504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefc3504",
  null
  
)

export default component.exports